/** Preferências de leitura no servidor (US-03, TASK-07).
 *
 * `PUT` e não `PATCH`: é um singleton de estado completo, e o merge é
 * last-write-wins no OBJETO INTEIRO. Mesclar campo a campo, sem carimbo por
 * campo, produziria um estado que nem o servidor nem o cliente tiveram — o tema
 * escolhido no celular com a fonte escolhida no laptop.
 */
import { api } from '@/services/api'
import type { ReaderPreferences, ReaderPreferencesResponse } from '@/types/api'

export async function fetchPreferences(): Promise<ReaderPreferencesResponse> {
  const { data } = await api.get<ReaderPreferencesResponse>('/reader/preferences')
  return data
}

export async function savePreferences(
  preferencias: ReaderPreferences,
  clientUpdatedAt: string,
): Promise<ReaderPreferencesResponse> {
  const { data } = await api.put<ReaderPreferencesResponse>('/reader/preferences', {
    ...preferencias,
    client_updated_at: clientUpdatedAt,
  })
  return data
}
